// Bir paketin gösterilecek fiyatı. Öncelik backend (PriceCalculationServiceImpl) ile aynı:
// firmaya özel fiyat > paket indirimi > liste fiyatı. İkisi birden varsa firmaya özel olan
// kazanır, üst üste binmezler. Hem paket listesi hem fiyat hesabı cevabıyla çalışır; ikisi de
// basePrice / discountedPrice / overridePrice / discountPercentage alanlarını taşır.
export const resolvePlanPricing = (plan) => {
    const list = plan?.basePrice
    if (plan?.overridePrice != null && plan.overridePrice !== list) {
        return { payable: plan.overridePrice, struck: list, percentage: null }
    }
    if (plan?.discountedPrice != null && list != null && plan.discountedPrice < list) {
        return {
            payable: plan.discountedPrice,
            struck: list,
            percentage: plan.discountPercentage ?? Math.round(((list - plan.discountedPrice) / list) * 100),
        }
    }
    return { payable: list, struck: null, percentage: null }
}
